import { CommonModule } from "@angular/common";
import { DxButtonModule } from "devextreme-angular";
import { RouterModule } from "@angular/router";
import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "general-config",
    imports: [CommonModule, DxButtonModule, RouterModule],
    templateUrl: "./general-config.page.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./general-config.page.css"]
})
export class GeneralConfigComponent {


  tabs = [
    { label: $localize`General`, routerLink: "general" },
    { label: $localize`Organizational Structure`, routerLink: "organization" }
    // Uncomment and adjust as needed for User Permissions tab
    // { label: $localize`User Permissions`, routerLink: "user-administration" }
  ];


}
